module.exports = __webpack_public_path__ + "img/aalogo.2c287ed5.png";